import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import formReducer from "./slices/formSlice";
import themeReducer from "./slices/themeSlice";
import authReducer from "./slices/authSlice";
import layoutReducer from "./slices/layoutSlice";
import distributorReducer from "./slices/distributorSlice";
import monitorReducer from "./slices/monitorSlice";

const formPersistConfig = {
  key: 'form',
  storage,
  whitelist: ['data'] // only data will be persisted
};

const themePersistConfig = {
  key: 'theme',
  storage,
  whitelist: ['mode'] // only mode will be persisted
};

const distributorPersistConfig = {
  key: 'distributor',
  storage,
  whitelist: ['selectedDistributor'] // only selectedDistributor will be persisted
};

const persistedFormReducer = persistReducer(formPersistConfig, formReducer);
const persistedThemeReducer = persistReducer(themePersistConfig, themeReducer);
const persistedDistributorReducer = persistReducer(distributorPersistConfig, distributorReducer);

export const store = configureStore({
  reducer: {
    form: persistedFormReducer,
    theme: persistedThemeReducer,
    auth: authReducer,
    layout: layoutReducer,
    distributor: persistedDistributorReducer,
    monitor: monitorReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

// For TypeScript
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
